// extracted by mini-css-extract-plugin
var _1 = "NameEdit_wrapper__gjcv5";
export { _1 as "wrapper" }
